// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.value_your_trade_card[data-v-60c9a1f8] {
  border: 1px solid #eee;
  border-radius: 15px;
  padding: 1px;
}
.custom_legend[data-v-60c9a1f8] {
  position: absolute;
  display: inline-block;
  background: #fff;
  z-index: 9;
  font-size: 12px;
  top: -12px;
  left: 30px;
  padding: 0 6px;
  color: #000;
  opacity: 0.8;
}
.card_font_sizes h5[data-v-60c9a1f8] {
  font-size: 12px;
  font-weight: 600;
  color: #000;
  white-space: initial;
}
.card_font_sizes p[data-v-60c9a1f8] {
  margin-bottom: 5px;
  font-size: 11px;
  white-space: initial;
}
.min-120[data-v-60c9a1f8] {
  min-height: 120px;
}
.value_your_trade_graphic[data-v-60c9a1f8] {
  border: 1px solid #eee;
  border-radius: 15px;
  padding: 1px;
}
.value_your_trade_graphic .iframe_box[data-v-60c9a1f8] {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px 0 0 0;
  height: 400px;
}
.value_your_trade_graphic iframe[data-v-60c9a1f8] {
  height: 100%;
  display: block;
  margin: auto;
}
.animate_bottom[data-v-60c9a1f8] {
  animation: animateBottom-60c9a1f8 2s;
  transition: 0.5s;
}
@keyframes animateBottom-60c9a1f8 {
0% {
    transform: translateY(50px);
}
100% {
    transform: translateY(0);
}
}
@media (min-width: 1900px) {
.custom_legend[data-v-60c9a1f8] {
    font-size: 13px;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatWidget/SlideOutPanel/TvmSlideOutKbbTradeValue/TvmSlideOutKbbTradeValue.vue","webpack://./TvmSlideOutKbbTradeValue.vue"],"names":[],"mappings":"AAEA;EACE,sBAAA;EACA,mBAAA;EACA,YAAA;ACDF;ADGA;EACE,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;ACDF;ADGA;EAEI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;ACFJ;ADHA;EAQI,kBAAA;EACA,eAAA;EACA,oBAAA;ACFJ;ADKA;EACE,iBAAA;ACHF;ADMA;EAjCE,sBAAA;EACA,mBAAA;EACA,YAAA;AC8BF;ADCA;EAGI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,aAAA;ACDJ;ADNA;EAUI,YAAA;EACA,cAAA;EACA,YAAA;ACDJ;ADIA;EACE,oCAAA;EACA,gBAAA;ACFF;ADIA;AACE;IACE,2BAAA;ACFF;ADIA;IACE,wBAAA;ACFF;AACF;ADIA;AACE;IACE,eAAA;ACFF;AACF","sourcesContent":["\n// reuseable css\n.value_your_trade_card {\n  border: 1px solid #eee;\n  border-radius: 15px;\n  padding: 1px;\n}\n.custom_legend {\n  position: absolute;\n  display: inline-block;\n  background: #fff;\n  z-index: 9;\n  font-size: 12px;\n  top: -12px;\n  left: 30px;\n  padding: 0 6px;\n  color: #000;\n  opacity: 0.8;\n}\n.card_font_sizes {\n  h5 {\n    font-size: 12px;\n    font-weight: 600;\n    color: #000;\n    white-space: initial;\n  }\n  p {\n    margin-bottom: 5px;\n    font-size: 11px;\n    white-space: initial;\n  }\n}\n.min-120 {\n  min-height: 120px;\n}\n// end reuseable css\n.value_your_trade_graphic {\n  .value_your_trade_card();\n  .iframe_box {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 5px 0 0 0;\n    height: 400px;\n  }\n  iframe {\n    height: 100%;\n    display: block;\n    margin: auto;\n  }\n}\n.animate_bottom {\n  animation: animateBottom 2s;\n  transition: 0.5s;\n}\n@keyframes animateBottom {\n  0% {\n    transform: translateY(50px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n@media (min-width: 1900px) {\n  .custom_legend {\n    font-size: 13px;\n  }\n}\n",".value_your_trade_card {\n  border: 1px solid #eee;\n  border-radius: 15px;\n  padding: 1px;\n}\n.custom_legend {\n  position: absolute;\n  display: inline-block;\n  background: #fff;\n  z-index: 9;\n  font-size: 12px;\n  top: -12px;\n  left: 30px;\n  padding: 0 6px;\n  color: #000;\n  opacity: 0.8;\n}\n.card_font_sizes h5 {\n  font-size: 12px;\n  font-weight: 600;\n  color: #000;\n  white-space: initial;\n}\n.card_font_sizes p {\n  margin-bottom: 5px;\n  font-size: 11px;\n  white-space: initial;\n}\n.min-120 {\n  min-height: 120px;\n}\n.value_your_trade_graphic {\n  border: 1px solid #eee;\n  border-radius: 15px;\n  padding: 1px;\n}\n.value_your_trade_graphic .iframe_box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 5px 0 0 0;\n  height: 400px;\n}\n.value_your_trade_graphic iframe {\n  height: 100%;\n  display: block;\n  margin: auto;\n}\n.animate_bottom {\n  animation: animateBottom 2s;\n  transition: 0.5s;\n}\n@keyframes animateBottom {\n  0% {\n    transform: translateY(50px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n@media (min-width: 1900px) {\n  .custom_legend {\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
